import type { PropsWithChildren } from 'react';
import { BrowserRouter } from 'react-router-dom';

/** Central place to add future providers (theme, i18n, query client, error boundary). */
export function AppProviders({ children }: PropsWithChildren) {
  return <BrowserRouter>{children}</BrowserRouter>;
}